import moment from "moment";

export const INITIAL_VALUES_MAP = {
  SOW: {
    quoteName: "",
    documentName: "",
    selectedPriceListID: "",
    deadlineDate: moment(Date()).add("days", 5),
    effectiveStartDate: moment().format(),
    expiryDate: moment(Date()).add("years", 1),
    contractStartDate: moment().format(),
  },
  SLA: {
    quoteName: "",
    documentName: "",
    selectedPriceListID: "",
    deadlineDate: moment(Date()).add("days", 5),
    effectiveStartDate: moment().format(),
    expiryDate: moment(Date()).add("years", 1),
    contractStartDate: moment().format(),
  },
  QUO: {
    quoteName: "",
    documentName: "",
    selectedPriceListID: "",
    deadlineDate: moment(Date()).add("days", 5),
    effectiveStartDate: moment().format(),
    expiryDate: moment(Date()).add("days", 30),
    contractStartDate: moment().format(),
  },
  MSA: {
    quoteName: "",
    documentName: "",
    selectedPriceListID: "",
    deadlineDate: moment(Date()).add("days", 5),
    effectiveStartDate: moment().format(),
    expiryDate: moment(Date()).add("years", 1),
    contractStartDate: moment().format(),
  },
  DPA: {
    quoteName: "",
    documentName: "",
    selectedPriceListID: "",
    deadlineDate: moment(Date()).add("days", 5),
    effectiveStartDate: moment().format(),
    expiryDate: moment(Date()).add("years", 1),
    contractStartDate: moment().format(),
  },
  CSA: {
    quoteName: "",
    documentName: "",
    selectedPriceListID: "",
    deadlineDate: moment(Date()).add("days", 5),
    effectiveStartDate: moment().format(),
    expiryDate: moment(Date()).add("years", 1),
    contractStartDate: moment().format(),
  },
  NDA: {
    quoteName: "",
    documentName: "",
    selectedPriceListID: "",
    deadlineDate: moment(Date()).add("days", 5),
    effectiveStartDate: moment().format(),
    expiryDate: moment(Date()).add("years", 1),
  },
  SAQ: {
    quoteName: "",
    documentName: "",
    selectedPriceListID: "",
    deadlineDate: moment(Date()).add("days", 5),
    contractStartDate: moment().format(),
  },
};

export const CREATE_QUOTE_FORM_MAP = {
  SOW: [
    {
      label: "DOCUMENT ID",
      name: "quoteName",
      placeholder: "Enter Document Id",
      type: "text",
      required: false,
      defaultVal: "",
      span: "full",
      classes: "",
      errorClassName: "danger-border",
      visibility: true,
      order: 0,
      applicable: true,
      disabled: true,
    },
    {
      label: "DOCUMENT NAME",
      name: "documentName",
      placeholder: "Enter Document Name",
      type: "text",
      required: true,
      defaultVal: "",
      span: "full",
      classes: "",
      errorClassName: "danger-border",
      visibility: true,
      order: 0,
      applicable: true,
      disabled: false,
    },
    {
      label: "PRICEBOOK",
      name: "selectedPriceListID",
      placeholder: "Select Pricebook",
      type: "select",
      required: true,
      defaultVal: "",
      span: "full",
      classes: "",
      errorClassName: "danger-border",
      visibility: true,
      order: 0,
      applicable: true,
      disabled: false,
    },
    {
      label: "TURNAROUND DATE",
      name: "deadlineDate",
      placeholder: "",
      type: "date",
      required: false,
      defaultVal: moment(Date()).add("days", 5),
      span: "full",
      classes: "bottom-border-field",
      errorClassName: "danger-border",
      visibility: true,
      order: 0,
      applicable: true,
      disabled: false,
      tooltipText:
        "The date by when you need the document to be sent to the customer.",
    },
    {
      label: "EFFECTIVE START DATE",
      name: "effectiveStartDate",
      placeholder: "",
      type: "date",
      required: false,
      defaultVal: moment().format(),
      span: "full",
      classes: "revv-form-items-half-span",
      errorClassName: "danger-border",
      visibility: true,
      order: 0,
      applicable: true,
      disabled: false,
      tooltipText: "The date the document becomes effecive.",
    },
    {
      label: "EXPIRY DATE",
      name: "expiryDate",
      placeholder: "",
      type: "date",
      required: false,
      defaultVal: moment(Date()).add("years", 1),
      span: "full",
      classes: "revv-form-items-half-span",
      errorClassName: "danger-border",
      visibility: true,
      order: 0,
      applicable: true,
      disabled: false,
      tooltipText: "The date the document expires as per the agreement term.",
    },
    {
      label: "CREATION DATE",
      name: "contractStartDate",
      placeholder: "",
      type: "date",
      required: false,
      defaultVal: moment().format(),
      span: "full",
      classes: "",
      errorClassName: "danger-border",
      visibility: true,
      order: 0,
      applicable: true,
      disabled: false,
      tooltipText: "The Date you start working on the document.",
    },
  ],
  SLA: [
    {
      label: "DOCUMENT ID",
      name: "quoteName",
      placeholder: "Enter Document Id",
      type: "text",
      required: false,
      defaultVal: "",
      span: "full",
      classes: "",
      errorClassName: "danger-border",
      visibility: true,
      order: 0,
      applicable: true,
      disabled: true,
    },
    {
      label: "DOCUMENT NAME",
      name: "documentName",
      placeholder: "Enter Document Name",
      type: "text",
      required: true,
      defaultVal: "",
      span: "full",
      classes: "",
      errorClassName: "danger-border",
      visibility: true,
      order: 0,
      applicable: true,
      disabled: false,
    },
    {
      label: "PRICEBOOK",
      name: "selectedPriceListID",
      placeholder: "Select Pricebook",
      type: "select",
      required: true,
      defaultVal: "",
      span: "full",
      classes: "",
      errorClassName: "danger-border",
      visibility: true,
      order: 0,
      applicable: true,
      disabled: false,
    },
    {
      label: "TURNAROUND DATE",
      name: "deadlineDate",
      placeholder: "",
      type: "date",
      required: false,
      defaultVal: moment(Date()).add("days", 5),
      span: "full",
      classes: "bottom-border-field",
      errorClassName: "danger-border",
      visibility: true,
      order: 0,
      applicable: true,
      disabled: false,
      tooltipText:
        "The date by when you need the document to be sent to the customer.",
    },
    {
      label: "EFFECTIVE START DATE",
      name: "effectiveStartDate",
      placeholder: "",
      type: "date",
      required: false,
      defaultVal: moment().format(),
      span: "full",
      classes: "revv-form-items-half-span",
      errorClassName: "danger-border",
      visibility: true,
      order: 0,
      applicable: true,
      disabled: false,
      tooltipText: "The date the document becomes effecive.",
    },
    {
      label: "EXPIRY DATE",
      name: "expiryDate",
      placeholder: "",
      type: "date",
      required: false,
      defaultVal: moment(Date()).add("years", 1),
      span: "full",
      classes: "revv-form-items-half-span",
      errorClassName: "danger-border",
      visibility: true,
      order: 0,
      applicable: true,
      disabled: false,
      tooltipText: "The date the document expires as per the agreement term.",
    },
    {
      label: "CREATION DATE",
      name: "contractStartDate",
      placeholder: "",
      type: "date",
      required: false,
      defaultVal: moment().format(),
      span: "full",
      classes: "",
      errorClassName: "danger-border",
      visibility: true,
      order: 0,
      applicable: true,
      disabled: false,
      tooltipText: "The Date you start working on the document.",
    },
  ],
  QUO: [
    {
      label: "DOCUMENT ID",
      name: "quoteName",
      placeholder: "Enter Document Id",
      type: "text",
      required: false,
      defaultVal: "",
      span: "full",
      classes: "",
      errorClassName: "danger-border",
      visibility: true,
      order: 0,
      applicable: true,
      disabled: true,
    },
    {
      label: "DOCUMENT NAME",
      name: "documentName",
      placeholder: "Enter Document Name",
      type: "text",
      required: true,
      defaultVal: "",
      span: "full",
      classes: "",
      errorClassName: "danger-border",
      visibility: true,
      order: 0,
      applicable: true,
      disabled: false,
    },
    {
      label: "PRICEBOOK",
      name: "selectedPriceListID",
      placeholder: "Select Pricebook",
      type: "select",
      required: true,
      defaultVal: "",
      span: "full",
      classes: "",
      errorClassName: "danger-border",
      visibility: true,
      order: 0,
      applicable: true,
      disabled: false,
    },
    {
      label: "TURNAROUND DATE",
      name: "deadlineDate",
      placeholder: "",
      type: "date",
      required: false,
      defaultVal: moment(Date()).add("days", 5),
      span: "full",
      classes: "bottom-border-field",
      errorClassName: "danger-border",
      visibility: true,
      order: 0,
      applicable: true,
      disabled: false,
      tooltipText:
        "The date by when you need the document to be sent to the customer.",
    },
    {
      label: "EFFECTIVE START DATE",
      name: "effectiveStartDate",
      placeholder: "",
      type: "date",
      required: false,
      defaultVal: moment().format(),
      span: "",
      classes: "revv-form-items-half-span",
      errorClassName: "danger-border",
      visibility: true,
      order: 0,
      applicable: true,
      disabled: false,
      tooltipText: "The date the document becomes effecive.",
    },
    {
      label: "EXPIRY DATE",
      name: "expiryDate",
      placeholder: "",
      type: "date",
      required: false,
      defaultVal: moment(Date()).add("years", 1),
      span: "",
      classes: "revv-form-items-half-span",
      errorClassName: "danger-border",
      visibility: true,
      order: 0,
      applicable: true,
      disabled: false,
      tooltipText: "The date the document expires as per the agreement term.",
    },
    {
      label: "CREATION DATE",
      name: "contractStartDate",
      placeholder: "",
      type: "date",
      required: false,
      defaultVal: moment().format(),
      span: "full",
      classes: "",
      errorClassName: "danger-border",
      visibility: true,
      order: 0,
      applicable: true,
      disabled: false,
      tooltipText: "The Date you start working on the document.",
    },
  ],
  MSA: [
    {
      label: "DOCUMENT ID",
      name: "quoteName",
      placeholder: "Enter Document Id",
      type: "text",
      required: false,
      defaultVal: "",
      span: "full",
      classes: "",
      errorClassName: "danger-border",
      visibility: true,
      order: 0,
      applicable: true,
      disabled: true,
    },
    {
      label: "DOCUMENT NAME",
      name: "documentName",
      placeholder: "Enter Document Name",
      type: "text",
      required: true,
      defaultVal: "",
      span: "full",
      classes: "",
      errorClassName: "danger-border",
      visibility: true,
      order: 0,
      applicable: true,
      disabled: false,
    },
    {
      label: "PRICEBOOK",
      name: "selectedPriceListID",
      placeholder: "Select Pricebook",
      type: "select",
      required: true,
      defaultVal: "",
      span: "full",
      classes: "",
      errorClassName: "danger-border",
      visibility: true,
      order: 0,
      applicable: true,
      disabled: false,
    },
    {
      label: "TURNAROUND DATE",
      name: "deadlineDate",
      placeholder: "",
      type: "date",
      required: false,
      defaultVal: moment(Date()).add("days", 5),
      span: "full",
      classes: "bottom-border-field",
      errorClassName: "danger-border",
      visibility: true,
      order: 0,
      applicable: true,
      disabled: false,
      tooltipText:
        "The date by when you need the document to be sent to the customer.",
    },
    {
      label: "EFFECTIVE START DATE",
      name: "effectiveStartDate",
      placeholder: "",
      type: "date",
      required: false,
      defaultVal: moment().format(),
      span: "full",
      classes: "revv-form-items-half-span",
      errorClassName: "danger-border",
      visibility: true,
      order: 0,
      applicable: true,
      disabled: false,
      tooltipText: "The date the document becomes effecive.",
    },
    {
      label: "EXPIRY DATE",
      name: "expiryDate",
      placeholder: "",
      type: "date",
      required: false,
      defaultVal: moment(Date()).add("years", 1),
      span: "full",
      classes: "revv-form-items-half-span",
      errorClassName: "danger-border",
      visibility: true,
      order: 0,
      applicable: true,
      disabled: false,
      tooltipText: "The date the document expires as per the agreement term.",
    },
    {
      label: "CREATION DATE",
      name: "contractStartDate",
      placeholder: "",
      type: "date",
      required: false,
      defaultVal: moment().format(),
      span: "full",
      classes: "",
      errorClassName: "danger-border",
      visibility: true,
      order: 0,
      applicable: true,
      disabled: false,
      tooltipText: "The Date you start working on the document.",
    },
  ],
  DPA: [
    {
      label: "DOCUMENT ID",
      name: "quoteName",
      placeholder: "Enter Document Id",
      type: "text",
      required: false,
      defaultVal: "",
      span: "full",
      classes: "",
      errorClassName: "danger-border",
      visibility: true,
      order: 0,
      applicable: true,
      disabled: true,
    },
    {
      label: "DOCUMENT NAME",
      name: "documentName",
      placeholder: "Enter Document Name",
      type: "text",
      required: true,
      defaultVal: "",
      span: "full",
      classes: "",
      errorClassName: "danger-border",
      visibility: true,
      order: 0,
      applicable: true,
      disabled: false,
    },
    {
      label: "PRICEBOOK",
      name: "selectedPriceListID",
      placeholder: "Select Pricebook",
      type: "select",
      required: true,
      defaultVal: "",
      span: "full",
      classes: "",
      errorClassName: "danger-border",
      visibility: true,
      order: 0,
      applicable: true,
      disabled: false,
    },
    {
      label: "TURNAROUND DATE",
      name: "deadlineDate",
      placeholder: "",
      type: "date",
      required: false,
      defaultVal: moment(Date()).add("days", 5),
      span: "full",
      classes: "bottom-border-field",
      errorClassName: "danger-border",
      visibility: true,
      order: 0,
      applicable: true,
      disabled: false,
      tooltipText:
        "The date by when you need the document to be sent to the customer.",
    },
    {
      label: "EFFECTIVE START DATE",
      name: "effectiveStartDate",
      placeholder: "",
      type: "date",
      required: false,
      defaultVal: moment().format(),
      span: "full",
      classes: "revv-form-items-half-span",
      errorClassName: "danger-border",
      visibility: true,
      order: 0,
      applicable: true,
      disabled: false,
      tooltipText: "The date the document becomes effecive.",
    },
    {
      label: "EXPIRY DATE",
      name: "expiryDate",
      placeholder: "",
      type: "date",
      required: false,
      defaultVal: moment(Date()).add("years", 1),
      span: "full",
      classes: "revv-form-items-half-span",
      errorClassName: "danger-border",
      visibility: true,
      order: 0,
      applicable: true,
      disabled: false,
      tooltipText: "The date the document expires as per the agreement term.",
    },
    {
      label: "CREATION DATE",
      name: "contractStartDate",
      placeholder: "",
      type: "date",
      required: false,
      defaultVal: moment().format(),
      span: "full",
      classes: "",
      errorClassName: "danger-border",
      visibility: true,
      order: 0,
      applicable: true,
      disabled: false,
      tooltipText: "The Date you start working on the document.",
    },
  ],
  NDA: [
    {
      label: "DOCUMENT ID",
      name: "quoteName",
      placeholder: "Enter Document Id",
      type: "text",
      required: false,
      defaultVal: "",
      span: "full",
      classes: "",
      errorClassName: "danger-border",
      visibility: true,
      order: 0,
      applicable: true,
      disabled: true,
    },
    {
      label: "DOCUMENT NAME",
      name: "documentName",
      placeholder: "Enter Document Name",
      type: "text",
      required: true,
      defaultVal: "",
      span: "full",
      classes: "",
      errorClassName: "danger-border",
      visibility: true,
      order: 0,
      applicable: true,
      disabled: false,
    },
    {
      label: "PRICEBOOK",
      name: "selectedPriceListID",
      placeholder: "Select Pricebook",
      type: "select",
      required: true,
      defaultVal: "",
      span: "full",
      classes: "",
      errorClassName: "danger-border",
      visibility: true,
      order: 0,
      applicable: true,
      disabled: false,
    },
    {
      label: "TURNAROUND DATE",
      name: "deadlineDate",
      placeholder: "",
      type: "date",
      required: false,
      defaultVal: moment(Date()).add("days", 5),
      span: "full",
      classes: "bottom-border-field",
      errorClassName: "danger-border",
      visibility: true,
      order: 0,
      applicable: true,
      disabled: false,
      tooltipText:
        "The date by when you need the document to be sent to the customer.",
    },
    {
      label: "EFFECTIVE START DATE",
      name: "effectiveStartDate",
      placeholder: "",
      type: "date",
      required: false,
      defaultVal: moment().format(),
      span: "full",
      classes: "revv-form-items-half-span",
      errorClassName: "danger-border",
      visibility: true,
      order: 0,
      applicable: true,
      disabled: false,
      tooltipText: "The date the document becomes effecive.",
    },
    {
      label: "EXPIRY DATE",
      name: "expiryDate",
      placeholder: "",
      type: "date",
      required: false,
      defaultVal: moment(Date()).add("years", 1),
      span: "full",
      classes: "revv-form-items-half-span",
      errorClassName: "danger-border",
      visibility: true,
      order: 0,
      applicable: true,
      disabled: false,
      tooltipText: "The date the document expires as per the agreement term.",
    },
  ],
  CSA: [
    {
      label: "DOCUMENT ID",
      name: "quoteName",
      placeholder: "Enter Document Id",
      type: "text",
      required: false,
      defaultVal: "",
      span: "full",
      classes: "",
      errorClassName: "danger-border",
      visibility: true,
      order: 0,
      applicable: true,
      disabled: true,
    },
    {
      label: "DOCUMENT NAME",
      name: "documentName",
      placeholder: "Enter Document Name",
      type: "text",
      required: true,
      defaultVal: "",
      span: "full",
      classes: "",
      errorClassName: "danger-border",
      visibility: true,
      order: 0,
      applicable: true,
      disabled: false,
    },
    {
      label: "PRICEBOOK",
      name: "selectedPriceListID",
      placeholder: "Select Pricebook",
      type: "select",
      required: true,
      defaultVal: "",
      span: "full",
      classes: "",
      errorClassName: "danger-border",
      visibility: true,
      order: 0,
      applicable: true,
      disabled: false,
    },
    {
      label: "TURNAROUND DATE",
      name: "deadlineDate",
      placeholder: "",
      type: "date",
      required: false,
      defaultVal: moment(Date()).add("days", 5),
      span: "full",
      classes: "bottom-border-field",
      errorClassName: "danger-border",
      visibility: true,
      order: 0,
      applicable: true,
      disabled: false,
      tooltipText:
        "The date by when you need the document to be sent to the customer.",
    },
    {
      label: "EFFECTIVE START DATE",
      name: "effectiveStartDate",
      placeholder: "",
      type: "date",
      required: false,
      defaultVal: moment().format(),
      span: "full",
      classes: "revv-form-items-half-span",
      errorClassName: "danger-border",
      visibility: true,
      order: 0,
      applicable: true,
      disabled: false,
      tooltipText: "The date the document becomes effecive.",
    },
    {
      label: "EXPIRY DATE",
      name: "expiryDate",
      placeholder: "",
      type: "date",
      required: false,
      defaultVal: moment(Date()).add("years", 1),
      span: "full",
      classes: "revv-form-items-half-span",
      errorClassName: "danger-border",
      visibility: true,
      order: 0,
      applicable: true,
      disabled: false,
      tooltipText: "The date the document expires as per the agreement term.",
    },
    {
      label: "CREATION DATE",
      name: "contractStartDate",
      placeholder: "",
      type: "date",
      required: false,
      defaultVal: moment().format(),
      span: "full",
      classes: "",
      errorClassName: "danger-border",
      visibility: true,
      order: 0,
      applicable: true,
      disabled: false,
      tooltipText: "The Date you start working on the document.",
    },
  ],
  SAQ: [
    {
      label: "DOCUMENT ID",
      name: "quoteName",
      placeholder: "Enter Document Id",
      type: "text",
      required: false,
      defaultVal: "",
      span: "full",
      classes: "",
      errorClassName: "danger-border",
      visibility: true,
      order: 0,
      applicable: true,
      disabled: true,
    },
    {
      label: "DOCUMENT NAME",
      name: "documentName",
      placeholder: "Enter Document Name",
      type: "text",
      required: true,
      defaultVal: "",
      span: "full",
      classes: "",
      errorClassName: "danger-border",
      visibility: true,
      order: 0,
      applicable: true,
      disabled: false,
    },
    {
      label: "PRICEBOOK",
      name: "selectedPriceListID",
      placeholder: "Select Pricebook",
      type: "select",
      required: true,
      defaultVal: "",
      span: "full",
      classes: "",
      errorClassName: "danger-border",
      visibility: true,
      order: 0,
      applicable: true,
      disabled: false,
    },
    {
      label: "TURNAROUND DATE",
      name: "deadlineDate",
      placeholder: "",
      type: "date",
      required: false,
      defaultVal: moment(Date()).add("days", 5),
      span: "full",
      classes: "bottom-border-field",
      errorClassName: "danger-border",
      visibility: true,
      order: 0,
      applicable: true,
      disabled: false,
      tooltipText:
        "The date by when you need the document to be sent to the customer.",
    },
    {
      label: "CREATION DATE",
      name: "contractStartDate",
      placeholder: "",
      type: "date",
      required: false,
      defaultVal: moment().format(),
      span: "full",
      classes: "",
      errorClassName: "danger-border",
      visibility: true,
      order: 0,
      applicable: true,
      disabled: false,
      tooltipText: "The Date you start working on the document.",
    },
  ],
};

export const FORM_FIELD_RULES = {
  SOW: {
    documentName: {
      required: ({ value }) => value.trim("").length > 0,
    },
    selectedPriceListID: {
      required: ({ value }) => value !== 0,
    },
  },
  SLA: {
    documentName: {
      required: ({ value }) => value.trim("").length > 0,
    },
    selectedPriceListID: {
      required: ({ value }) => value !== 0,
    },
  },
  QUO: {
    documentName: {
      required: ({ value }) => value.trim("").length > 0,
    },
    selectedPriceListID: {
      required: ({ value }) => value !== 0,
    },
  },
  MSA: {
    documentName: {
      required: ({ value }) => value.trim("").length > 0,
    },
    selectedPriceListID: {
      required: ({ value }) => value !== 0,
    },
  },
  DPA: {
    documentName: {
      required: ({ value }) => value.trim("").length > 0,
    },
    selectedPriceListID: {
      required: ({ value }) => value !== 0,
    },
  },
  CSA: {
    documentName: {
      required: ({ value }) => value.trim("").length > 0,
    },
    selectedPriceListID: {
      required: ({ value }) => value !== 0,
    },
  },
  NDA: {
    documentName: {
      required: ({ value }) => value.trim("").length > 0,
    },
    selectedPriceListID: {
      required: ({ value }) => value !== 0,
    },
  },
  SAQ: {
    documentName: {
      required: ({ value }) => value.trim("").length > 0,
    },
    selectedPriceListID: {
      required: ({ value }) => value !== 0,
    },
  },
};

export const FORM_FIELD_MESSAGES = {
  SOW: {
    documentName: {
      required: "Please enter a document name",
    },
    selectedPriceListID: {
      required: "Please select a pricebook",
    },
  },
  SLA: {
    documentName: {
      required: "Please enter a document name",
    },
    selectedPriceListID: {
      required: "Please select a pricebook",
    },
  },
  QUO: {
    documentName: {
      required: "Please enter a document name",
    },
    selectedPriceListID: {
      required: "Please select a pricebook",
    },
  },
  MSA: {
    documentName: {
      required: "Please enter a document name",
    },
    selectedPriceListID: {
      required: "Please select a pricebook",
    },
  },
  DPA: {
    documentName: {
      required: "Please enter a document name",
    },
    selectedPriceListID: {
      required: "Please select a pricebook",
    },
  },
  CSA: {
    documentName: {
      required: "Please enter a document name",
    },
    selectedPriceListID: {
      required: "Please select a pricebook",
    },
  },
  NDA: {
    documentName: {
      required: "Please enter a document name",
    },
    selectedPriceListID: {
      required: "Please select a pricebook",
    },
  },
  SAQ: {
    documentName: {
      required: "Please enter a document name",
    },
    selectedPriceListID: {
      required: "Please select a pricebook",
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/CreateQuotePopup/CreateQuoteFormMap.js